import { useTranslation } from "@repo/shared/i18n";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import Spinner from "../../components/atoms/Spinner/Spinner";
import { AppDispatch } from "../../redux/store";
import { getUserSelector, unsubscribeEmail } from "../../redux/user/userSlice";

const EmailUnsubscribe = () => {
  const { t } = useTranslation("profile");
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("uuid");
  const cioId = searchParams.get("cio_id");
  const { unsubscribeEmailStatus } = useSelector(getUserSelector);

  useEffect(() => {
    dispatch(unsubscribeEmail({ userId, cioId }));
  }, [userId, cioId, dispatch]);

  return (
    <main className="text-white flex flex-col gap-y-8 items-center mt-8">
      <h1 className="text-2xl">{t("emailUnsubscribe.title")}</h1>
      <p>
        {unsubscribeEmailStatus === "pending" ? (
          <Spinner />
        ) : unsubscribeEmailStatus === "fulfilled" ? (
          <span>{t("emailUnsubscribe.success")}</span>
        ) : (
          <span>{t("emailUnsubscribe.error")}</span>
        )}
      </p>
    </main>
  );
};

export default EmailUnsubscribe;
